import { format } from 'date-fns';

export const BillingDayMode = Object.freeze({
  EffectiveDate: 'effective-date',
  Capped28: 'capped-28',
  Custom: 'custom'
});

// Not every month has a 29th–31st, so a policy effective on one of those days bills on the 28th.
export const LAST_BILLING_DAY = 28;

// 22 -> '22nd'
export const ordinalDay = (day) => format(new Date(2000, 0, day), 'do');

/**
 * A policy's billing day of the month and how it was chosen, from its saved billing day and effective
 * date (`effectiveDate` is an AWSDate, 'yyyy-MM-dd'). With no saved billing day, billing follows the
 * effective day, so the policy reads as `effective-date` or `capped-28`. Returns null without an
 * effective date.
 *
 * shortcut: the mode is derived by comparing the two days, so a custom 28th on a policy effective on
 * the 29th–31st reads as `capped-28`. Switch to the offer's stored "billing day follows the effective
 * date" flag once #35596 adds it.
 */
export const getBillingDay = ({ effectiveDate, billingDayOfMonth }) => {
  const effectiveDay = Number(effectiveDate?.slice(8, 10));
  if (!effectiveDay) {
    return null;
  }
  const defaultDay = Math.min(effectiveDay, LAST_BILLING_DAY);
  const day = billingDayOfMonth ? Number(billingDayOfMonth) : defaultDay;

  let mode = BillingDayMode.EffectiveDate;
  if (day !== defaultDay) {
    mode = BillingDayMode.Custom;
  } else if (effectiveDay > LAST_BILLING_DAY) {
    mode = BillingDayMode.Capped28;
  }
  return { day, effectiveDay, mode };
};
